export * from './ProductDetailTemplate';
export * from './brandCorner';
export * from './ProductDetailFooterSection';
export * from './ratingsAndReviews';
export * from './ProductDetailPageManager';
